import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { TituloReceberSituacaoModule } from '../../situacao';

import { TituloReceberTableComponent } from './titulo-receber-table.component';

@NgModule({
    imports: [
        SharedModule,
        TituloReceberSituacaoModule
    ],
    declarations: [
        TituloReceberTableComponent
    ],
    exports: [
        TituloReceberTableComponent
    ]
})
export class TituloReceberTableModule { }
